
import React, { useState, useEffect, useRef } from 'react';
import { testimonials } from '../../data/testimonials';

export default function TestimonialList() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState('next');
  const intervalRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const startAutoScroll = () => {
    intervalRef.current = setInterval(slideNext, 7000);
  };

  const stopAutoScroll = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAutoScroll();
    return () => stopAutoScroll();
  }, []);

  const slideNext = () => {
    setDirection('next');
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const slidePrev = () => {
    setDirection('prev');
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleDotClick = (index) => {
    setDirection(index > currentIndex ? 'next' : 'prev');
    setCurrentIndex(index);
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (touchStartX.current - touchEndX.current > 50) slideNext();
    if (touchStartX.current - touchEndX.current < -50) slidePrev();
  };

  return (
    <section
      className="w-full py-12 px-4 bg-gradient-to-r from-slate-50 via-blue-100 to-slate-50 rounded-xl shadow-lg my-12 relative overflow-hidden"
      onMouseEnter={stopAutoScroll}
      onMouseLeave={startAutoScroll}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {/* Floating background elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute w-20 h-20 bg-sky-200 rounded-full opacity-30 animate-float slow float-1"></div>
        <div className="absolute w-32 h-32 bg-blue-300 rounded-full opacity-20 animate-float slower float-2"></div>
        <div className="absolute w-16 h-16 bg-indigo-200 rounded-full opacity-25 animate-float slow float-3"></div>
      </div>

      <h2 className="text-2xl md:text-3xl font-bold text-sky-700 mb-8 text-center font-heading relative z-10">
        What Our Customers Say
      </h2>

      <div className="relative flex justify-center overflow-hidden h-64 sm:h-72 md:h-64 lg:h-64 z-10">
        {testimonials.map((t, i) => {
          let transformClass = 'translate-x-full opacity-0 scale-90';
          if (i === currentIndex) transformClass = 'translate-x-0 opacity-100 scale-105';
          else if (
            (direction === 'next' && i === currentIndex - 1) ||
            (direction === 'prev' && i === currentIndex + 1)
          )
            transformClass =
              direction === 'next' ? '-translate-x-full opacity-0 scale-90' : 'translate-x-full opacity-0 scale-90';

          return (
            <blockquote
              key={i}
              className={`absolute top-0 w-full max-w-lg bg-white backdrop-blur-md rounded-2xl shadow-lg p-6 transition-all duration-700 ease-in-out
              ${transformClass}`}
            >
              <p className="text-gray-800 text-base sm:text-lg italic mb-4">&ldquo;{t.text}&rdquo;</p>
              <footer className="flex items-center text-sm sm:text-base">
                <span className="font-semibold text-sky-600">{t.name}</span>
                <span className="ml-2 text-gray-500">({t.location})</span>
              </footer>
            </blockquote>
          );
        })}

        {/* Navigation arrows */}
        {/* <button
          onClick={slidePrev}
          className="lg:hidden absolute left-2 sm:left-0 bottom-1 -translate-y-1/2 bg-sky-600 text-white rounded-full p-2 sm:p-3 shadow-lg hover:bg-sky-700 transition-colors z-10"
        >
          &#8592;
        </button>
        <button
          onClick={slideNext}
          className="lg:hidden absolute right-2 sm:right-0 bottom-1 -translate-y-1/2 bg-sky-600 text-white rounded-full p-2 sm:p-3 shadow-lg hover:bg-sky-700 transition-colors z-10"
        >
          &#8594;
        </button> */}
      </div>

      {/* Navigation dots */}
      <div className="flex justify-center mt-6 space-x-2 relative z-10">
        {testimonials.map((_, i) => (
          <button
            key={i}
            onClick={() => handleDotClick(i)}
            className={`w-3 h-3 sm:w-4 sm:h-4 rounded-full transition-all ${
              i === currentIndex
                ? 'bg-sky-600 scale-125 shadow-md'
                : 'bg-gray-400 scale-100'
            }`}
          />
        ))}
      </div>
    </section>
  );
}
